module.exports = __webpack_public_path__ + "img/teacherimgplaceholder.842032fa.png";